import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Product } from '@models/product';

export interface ReturnInventoryLine {
  product: Product;
  model: string;
  color: string;
  size: string;
  maxQuantity: number;
  returnQuantity: number;
}

export interface ReturnInventoryDialogData {
  lines: ReturnInventoryLine[];
}

@Component({
  selector: 'app-return-inventory-dialog',
  templateUrl: './return-inventory-dialog.component.html',
  styleUrls: ['./return-inventory-dialog.component.css'],
})
export class ReturnInventoryDialogComponent {
  lines: ReturnInventoryLine[];

  constructor(
    public dialogRef: MatDialogRef<ReturnInventoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReturnInventoryDialogData
  ) {
    this.lines = data.lines.map((line) => ({ ...line }));
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    const valid = this.lines.every(
      (line) =>
        line.returnQuantity >= 1 &&
        line.returnQuantity <= line.maxQuantity &&
        Number.isInteger(+line.returnQuantity)
    );
    if (!valid) {
      return;
    }
    this.dialogRef.close(this.lines);
  }

  onQuantityChange(line: ReturnInventoryLine, value: string): void {
    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) {
      line.returnQuantity = 1;
      return;
    }
    line.returnQuantity = Math.min(
      Math.max(1, parsed),
      line.maxQuantity
    );
  }
}
